import { render, staticRenderFns } from "./UserPinCard.vue?vue&type=template&id=804003b8&scoped=true&"
import script from "./UserPinCard.vue?vue&type=script&lang=js&"
export * from "./UserPinCard.vue?vue&type=script&lang=js&"
import style0 from "./UserPinCard.vue?vue&type=style&index=0&id=804003b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804003b8",
  null
  
)

export default component.exports